/**
 * DTO used when creating new order assignment. Assigning order for
 * delivery when Delivery Provider is enabled for given Merchant.
 * NOTE: No validation needed as this is used to send notification TO Delivery Provider.
 */
export class CreateDeliveryJobForGigableRequestDto {
  /** Order Id from the system. */
  orderId: number;
  /**  Calculated time when Driver should pickup an order. */
  orderPickUpTime: Date;
  /**  Order requested time by the Customer. */
  requestedDateTime: Date;
  /** Merchant Id */
  locationId: string;
  /** Customer last name. */
  customerLastName: string;
  /** Customer address. */
  customerAddress: string;
  /** Customer phone. */
  customerPhone: string;
  /** Delivery location latitude. */
  latitude: number;
  /** Delivery location longitude. */
  longitude: number;
  /** Optional notes from the Customer. */
  notes: string;

  constructor({
    orderId,
    orderPickUpTime,
    requestedDateTime,
    locationId,
    customerLastName,
    customerAddress,
    customerPhone,
    latitude,
    longitude,
    notes
  }: {
    orderId: number;
    orderPickUpTime: Date;
    requestedDateTime: Date;
    locationId: string;
    customerLastName: string;
    customerAddress: string;
    customerPhone: string;
    latitude: number;
    longitude: number;
    notes?: string;
  }) {
    this.orderId = orderId;
    this.orderPickUpTime = orderPickUpTime;
    this.requestedDateTime = requestedDateTime;
    this.locationId = locationId;
    this.customerLastName = customerLastName;
    this.customerAddress = customerAddress;
    this.customerPhone = customerPhone;
    this.latitude = latitude;
    this.longitude = longitude;
    this.notes = notes || '';
  }
}
